import { reduce, upperFirst } from 'lodash';

/**
 * Populate destination propertys based on source propertys.
 *
 * @param {boolean} capDestProp - Capitalize destination property name
 * @param {Array} propertyNames - Propertys to iterate
 * @param {{}} source - Source Object
 * @returns {{}}
 */
const populatePropertys = (props = {}) => {
  const { capDestProp, source, propertyNames } = props;

  return reduce(
    propertyNames,
    (acc, curr) => {
      if (source[curr]) {
        const newProperty = capDestProp ? upperFirst(curr) : curr;

        return Object.assign({}, acc, { [newProperty]: source[curr] });
      }

      return acc;
    },
    {}
  );
};

export default populatePropertys;



// WEBPACK FOOTER //
// ./src/qoc-sdk/utils/populatePropertys.js